export const migrations = {
  0: (state) => {
    return {}
  },
};
